import TextArea from './text-area';

export default TextArea;
